import { render, staticRenderFns } from "./ClientTopRight.vue?vue&type=template&id=f38f7d06&scoped=true"
import script from "./ClientTopRight.vue?vue&type=script&lang=js"
export * from "./ClientTopRight.vue?vue&type=script&lang=js"
import style0 from "./ClientTopRight.vue?vue&type=style&index=0&id=f38f7d06&scoped=true&lang=css"
import style1 from "./ClientTopRight.vue?vue&type=style&index=1&id=f38f7d06&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38f7d06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f38f7d06')) {
      api.createRecord('f38f7d06', component.options)
    } else {
      api.reload('f38f7d06', component.options)
    }
    module.hot.accept("./ClientTopRight.vue?vue&type=template&id=f38f7d06&scoped=true", function () {
      api.rerender('f38f7d06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/client-view/home/components/ClientTopRight.vue"
export default component.exports